module.exports = __webpack_public_path__ + "img/facebookLogo.28d3110a.svg";